import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRolesRoutingModule } from './admin-roles-routing.module';
import { AdminRolesComponent } from './admin-roles.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { AdminRoleTableComponent } from './admin-role-table/admin-role-table.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../core/components/button/button.component';
import { ModalComponent } from '../core/components/modal/modal.component';
import { TextInputComponent } from '../core/components/text-input/text-input.component';

@NgModule({
    declarations: [AdminRolesComponent, AdminRoleTableComponent],
    imports: [
        CommonModule,
        AdminRolesRoutingModule,
        MatExpansionModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        FormsModule,
        ButtonComponent,
        ModalComponent,
        TextInputComponent,
    ],
})
export class AdminRolesModule {}
